import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'approximateRoundCount',
    standalone: false
})
export class ApproximateRoundCountPipe implements PipeTransform {
    transform(value: number): number {
        if (!value) {
            return 0;
        }
        if (value < 100) {
            return Math.round(value / 10) * 10;
        }
        if (value < 10000) {
            return Math.round(value / 100) * 100;
        }
        return Math.round(value / 1000) * 1000;
    }
}
